import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../App.js';
import { jwtDecode } from 'jwt-decode';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { setUser } = useContext(UserContext);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const API_URL = process.env.REACT_APP_API_URL;

            const response = await fetch(`${API_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('Identifiants de connexion invalides. Veuillez réessayer.');
                }
                const errorText = await response.text();
                try {
                    const errorData = JSON.parse(errorText);
                    throw new Error(errorData.message || 'Échec de la connexion');
                } catch (jsonError) {
                    if (errorText.startsWith('<!DOCTYPE html>')) {
                        throw new Error("Le serveur API a renvoyé une page HTML. Veuillez vérifier l'URL de l'API et la disponibilité du serveur.");
                    }
                    throw new Error('Échec de la connexion. Erreur inconnue du serveur.');
                }
            }

            const data = await response.json();
            const decodedToken = jwtDecode(data.accessToken);
            const userType = decodedToken.userType;

            // Check if the user is an admin or a supplier
            if (userType === 'admin' || userType === 'supplier' || userType === 'delivery') {
                setUser(decodedToken);
                localStorage.setItem('user', JSON.stringify(decodedToken));
                localStorage.setItem('accessToken', data.accessToken);

                // Redirect based on user type
                if (userType === 'admin') {
                    navigate('/'); // Admin dashboard
                } else if (userType === 'supplier') {
                    navigate('/supplier-dashboard'); // New supplier dashboard
                }
                else if (userType === 'delivery') {
                    navigate('/delivery-dashboard'); // New supplier dashboard
                }
            } else {
                setError('Accès refusé. Seuls les administrateurs et fournisseurs peuvent se connecter.');
            }

        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-xl">
                <img src='https://res.cloudinary.com/dynplclnn/image/upload/v1757705765/katabe-logo_fk0tn7.jpg' alt='logo'/>
                {/* <h1 className="text-3xl font-extrabold text-center text-gray-900">
                    Connexion au tableau de bord
                </h1> */}
                {loading && (
                    <div className="text-center text-blue-500 font-medium">
                        Chargement...
                    </div>
                )}
                {error && (
                    <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-md text-center">
                        {error}
                    </div>
                )}
                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Adresse e-mail
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Mot de passe
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full px-6 py-3 text-white font-semibold bg-blue-600 rounded-lg shadow-md hover:bg-blue-700 transition-colors disabled:bg-blue-400"
                    >
                        {loading ? 'Connexion en cours...' : 'Se connecter'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;